import React from 'react'

export default function ChevronLeftIcon({size}){
    return(
        <svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 0 9 17">
            <path d="M7.99 0a.576.576 0 0 1 .414.172.63.63 0 0 1 .025.872c-2.2 2.327-5.595 5.962-6.607 7.113 1.008 1.14 4.407 4.782 6.607 7.111a.631.631 0 0 1-.02.874.59.59 0 0 1-.848-.017C.438 8.554.438 8.476.438 8.148c0-.328 0-.398 7.118-7.96A.598.598 0 0 1 7.99 0"/>
        </svg>
    )
}